export class Category {
    constructor({ insuranceForm, state, calculateInsurance }) {
        this.$insuranceForm = insuranceForm;
        this._state = state;
        this._calculateInsurance = calculateInsurance;

        this.$select = this.$insuranceForm.find('#categorySelect');

        this._categories = [];
        this._selectedCategory = null;
        this._selectize = null;
    }

    init(categories) {
        this._categories = categories;

        this._selectize = $(this.$select).selectize({
            onItemAdd: this._selectCategory.bind(this),
        });

        this._selectize[0].selectize.addOption(this._categories);
        this._selectize[0].selectize.addItem('3');
    }

    _selectCategory(value) {
        this._selectedCategory = this._categories.find(category => category.value === +value);
        this._state.category = this._selectedCategory;
        this._calculateInsurance.calculateInsurance();
    }
}